
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";

export class PickTicketService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.pt_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_PT_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getPickTicketPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getPickTicketPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initPickTicketModule(input, responseCallBack, errorCallBack) {
    this.method("initPickTicketModule", input, responseCallBack, errorCallBack);
  }
  static updatePickTicket(input, responseCallBack, errorCallBack) {
    this.method("updatePickTicket", input, responseCallBack, errorCallBack);
  }
  static cancelPickTicket(input, responseCallBack, errorCallBack) {
    this.method("cancelPickTicket", input, responseCallBack, errorCallBack);
  }
  static unLockPickTicket(input, responseCallBack, errorCallBack) {
    this.method("unLockPickTicket", input, responseCallBack, errorCallBack);
  }
  static updatePickTicketAndCreateInvoice(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updatePickTicketAndCreateInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePickTicketAfterInvoiced(input, responseCallBack, errorCallBack) {
    this.method(
      "updatePickTicketAfterInvoiced",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePickTicketAndShipConfirmPickTicket(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updatePickTicketAndShipConfirmPickTicket",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static voidShipment(input, responseCallBack, errorCallBack) {
    this.method("voidShipment", input, responseCallBack, errorCallBack);
  }
  static getShipmentRatesForPickTicket(input, responseCallBack, errorCallBack) {
    this.method(
      "getShipmentRatesForPickTicket",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generateAdvancedPickTicketEntry(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "generateAdvancedPickTicketEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static generatePickTicketEntry(input, responseCallBack, errorCallBack) {
    this.method(
      "generatePickTicketEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static saveAdvancedPickTicketEntry(input, responseCallBack, errorCallBack) {
    this.method(
      "saveAdvancedPickTicketEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static syncPickTicketWithSalesOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "syncPickTicketWithSalesOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateShippedStatusInPickTicket(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateShippedStatusInPickTicket",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static printPickTicket(input, responseCallBack, errorCallBack) {
    this.method("printPickTicket", input, responseCallBack, errorCallBack);
  }
  static generatePickTicketEntry(input, responseCallBack, errorCallBack) {
    this.method(
      "generatePickTicketEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPickTickets(input, responseCallBack, errorCallBack) {
    this.method("getPickTickets", input, responseCallBack, errorCallBack);
  }
  static readPickTicket(input, responseCallBack, errorCallBack) {
    this.method("readPickTicket", input, responseCallBack, errorCallBack);
  }

  static updatePickTicketAndUpdateExistingInvoice(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updatePickTicketAndUpdateExistingInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static pickTicketImageUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "pickTicketImageUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static pickTicketDocUpload(input, responseCallBack, errorCallBack) {
    this.method("pickTicketDocUpload", input, responseCallBack, errorCallBack);
  }

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.pt_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.pt_data_url,responseCallBack, errorCallBack);

    }
  }
}
